<template lang="pug">
table-base.branch-list-table
  //- ヘッダー部
  table-row-base.branch-list-table__row-header.text-medium
    table-header-base.branch-list-table__row-header__cell
      .branch-list-table__row-header__cell__checkbox(:data-selected='checkedAll')
        input.branch-list-table__row-header__cell__checkbox__input(type='checkbox', v-model='isCheckedAll', :id='UID')
        label-base.branch-list-table__row-header__cell__checkbox__label(:for='UID')
    table-header-base.branch-list-table__row-header__cell.align-left
      toggle-sort.branch-list-table__row-header__cell__toggle(
        :sortSetting='sort.academyName',
        @change-sort='sortChangeEvent($event, "academyName")'
      )
        slot(name='academyNameHeader')
    table-header-base.branch-list-table__row-header__cell.align-left
      toggle-sort.branch-list-table__row-header__cell__toggle(
        :sortSetting='sort.branchName',
        @change-sort='sortChangeEvent($event, "branchName")'
      )
        slot(name='branchNameHeader')
    table-header-base.branch-list-table__row-header__cell.align-left
      toggle-sort.branch-list-table__row-header__cell__toggle(
        :sortSetting='sort.branchCode',
        @change-sort='sortChangeEvent($event, "branchCode")'
      )
        slot(name='branchCodeHeader')
    table-header-base.branch-list-table__row-header__cell.align-left
      toggle-sort.branch-list-table__row-header__cell__toggle(
        :sortSetting='sort.updatedDate',
        @change-sort='sortChangeEvent($event, "updatedDate")'
      )
        slot(name='updatedDateHeader')
    table-header-base.branch-list-table__row-header__cell.align-center
      slot(name='editHeader')
  template(v-for='branch in branchDatas')
    //- 一覧表示部
    table-row-base.branch-list-table__row.text-small.font-medium
      table-data-base.branch-list-table__row__cell
        .branch-list-table__row__cell__checkbox(:data-selected='dataSelected(branch.id)')
          input.branch-list-table__row__cell__checkbox__input(
            type='checkbox',
            :value='branch.id',
            v-model='selectedValue',
            :id='getInputId(branch.id)'
          )
          label-base.branch-list-table__row__cell__checkbox__label(:for='getInputId(branch.id)')
      table-data-base.branch-list-table__row__cell
        .branch-list-table__row__cell__text {{ branch.academyName }}
      table-data-base.branch-list-table__row__cell
        .branch-list-table__row__cell__text {{ branch.branchName }}
      table-data-base.branch-list-table__row__cell
        .branch-list-table__row__cell__text {{ branch.branchCode }}
      table-data-base.branch-list-table__row__cell
        .branch-list-table__row__cell__date-text {{ branch.updatedDate }}
      table-data-base.branch-list-table__row__cell
        popup-edit.branch-list-table__row__cell__popup(
          :deleteEvent='deleteEvent',
          :editEvent='editEvent',
          :editId='branch.id'
        )
          template(#removeText)
            slot(name='popupRemoveText')
          template(#editText)
            slot(name='popupEditText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import ToggleSort from '@/components/molecules/manager/ToggleSort.vue'
import PopupEdit from '@/components/organisms/manager/PopupEdit.vue'
import { BranchListType, BranchListSortType } from '@/models/branchListModel'

/**
 * 教室一覧テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    LabelBase,
    ToggleSort,
    PopupEdit,
  },
})
export default class BranchListTable extends Vue {
  // 全チェックフラグ
  @Prop()
  checkedAll!: boolean

  // ヘッダーチェックボックスの変更イベント
  @Prop()
  headerCheckboxChangeEvent!: Function

  // ソート値（項目毎の昇順フラグ）
  @Prop()
  sort!: BranchListSortType

  // ソート値変更時イベント
  @Prop()
  sortChangeEvent!: Function

  // 教室一覧情報
  @Prop()
  branchDatas!: BranchListType[]

  // 一覧内チェックボックスのチェックされた教室ID
  @Prop()
  checkedBranchIds!: number[]

  // 一覧内チェックボックスの変更イベント
  @Prop()
  checkboxChangeEvent!: Function

  // 削除イベント
  @Prop()
  deleteEvent!: Function

  // 編集イベント
  @Prop()
  editEvent!: Function

  // コンポーネント単位のユニークID取得
  private readonly UID = this.$uuid.v4()

  // inputタグの個別ID
  private getInputId(id: number): string {
    return `id${this.UID}_${id}`
  }

  // 選択状態に応じてカスタムデータ属性を付与
  private dataSelected(value: number): boolean {
    return this.checkedBranchIds.includes(value)
  }

  /**
   * ヘッダーチェックボックスのゲッターセッター
   */
  get isCheckedAll(): boolean {
    return this.checkedAll
  }
  set isCheckedAll(value: boolean) {
    // チェック時は一覧内の全チェックボックスをチェック、チェック解除時は全チェックボックスをチェック解除する
    const checkedIds = value
      ? this.branchDatas.map((branch) => {
          return branch.id
        })
      : []
    this.checkboxChangeEvent(checkedIds)
    this.headerCheckboxChangeEvent(value)
  }

  /**
   * チェックボックス選択値のゲッターセッター
   */
  get selectedValue(): number[] {
    return this.checkedBranchIds
  }
  set selectedValue(value: number[]) {
    // 全チェックボックスがチェックされていなければヘッダーのチェックボックスをチェック解除する
    if (value.length < this.branchDatas.length) {
      this.headerCheckboxChangeEvent(false)
    }
    this.checkboxChangeEvent(value)
  }
}
</script>

<style lang="stylus" scoped>
.branch-list-table
  width 100%

  &__row-header,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

    &__cell
      &__checkbox
        display flex
        align-items center
        justify-content center

        &__input
          display none

        &__label
          width 20px
          height 20px
          background-image url("~@/assets/img/common/checkbox/off.svg")

        &[data-selected='true'] &__label
          background-image url("~@/assets/img/common/checkbox/on.svg")


  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

      &:nth-child(1)
        width 65px
      &:nth-last-child(2)
        width 215px
      &:nth-last-child(1)
        width 130px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 20px

      &__date-text
        opacity 0.4

      &__popup
        justify-content center

    &:hover
      background var(--color-manager-list__hover)
</style>
